{
  "cell": 128,
  "columns": 7,
  "height": 896,
  "items": {
    "arrow": [
      0,
      3
    ],
    "arrow-bundle": [
      6,
      2
    ],
    "axe-1h": [
      1,
      3
    ],
    "axe-2h": [
      2,
      3
    ],
    "chest-brigandine": [
      0,
      0
    ],
    "chest-cuirass": [
      1,
      0
    ],
    "chest-tabard": [
      2,
      0
    ],
    "crossbow-1h": [
      3,
      3
    ],
    "crossbow-2h": [
      4,
      3
    ],
    "dagger": [
      5,
      3
    ],
    "head-great-helm": [
      3,
      0
    ],
    "head-hood": [
      4,
      0
    ],
    "head-kettle-helm": [
      5,
      0
    ],
    "mug-empty": [
      6,
      3
    ],
    "mug-full": [
      0,
      4
    ],
    "quiver": [
      1,
      4
    ],
    "shield-badge": [
      3,
      4
    ],
    "shield-badge-color": [
      2,
      4
    ],
    "shield-round": [
      6,
      4
    ],
    "shield-round-barbarian": [
      4,
      4
    ],
    "shield-round-color": [
      5,
      4
    ],
    "shield-spikes": [
      1,
      5
    ],
    "shield-spikes-color": [
      0,
      5
    ],
    "shield-square": [
      3,
      5
    ],
    "shield-square-color": [
      2,
      5
    ],
    "shoulder-lantern-mantle.l": [
      6,
      0
    ],
    "shoulder-lantern-mantle.r": [
      0,
      1
    ],
    "shoulder-leather-pads.l": [
      1,
      1
    ],
    "shoulder-leather-pads.r": [
      2,
      1
    ],
    "shoulder-plate-pauldrons.l": [
      3,
      1
    ],
    "shoulder-plate-pauldrons.r": [
      4,
      1
    ],
    "smokebomb": [
      4,
      5
    ],
    "spellbook-closed": [
      5,
      5
    ],
    "spellbook-open": [
      6,
      5
    ],
    "staff": [
      0,
      6
    ],
    "sword-1h": [
      1,
      6
    ],
    "sword-2h": [
      3,
      6
    ],
    "sword-2h-color": [
      2,
      6
    ],
    "wand": [
      4,
      6
    ],
    "weapon-vanguard-axe": [
      5,
      1
    ],
    "weapon-vanguard-hammer": [
      6,
      1
    ],
    "weapon-vanguard-shield": [
      0,
      2
    ],
    "weapon-vanguard-sword": [
      1,
      2
    ],
    "weapon-warden-censer-mace": [
      2,
      2
    ],
    "weapon-warden-hymnal": [
      3,
      2
    ],
    "weapon-warden-lantern-staff": [
      4,
      2
    ],
    "weapon-warden-wand": [
      5,
      2
    ]
  },
  "note": "items map an id to [col, row]; rows count from the TOP, as CSS background-position does",
  "rows": 7,
  "width": 896
}
